import { FC } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router';

import { PATHS } from '@/shared/config/paths';
import { InfoBanner } from '@/shared/ui';

type SubscriptionPurchasePromptBannerProps = {
  isOwner: boolean;
};

export const SubscriptionPurchasePromptBanner: FC<
  SubscriptionPurchasePromptBannerProps
> = (props) => {
  const { isOwner } = props;

  const navigate = useNavigate();
  const { formatMessage } = useIntl();

  const handleBillingNavigate = () => {
    navigate({
      pathname: PATHS.companySettings,
      search: 'tab=BillingInfo',
    });
  };

  return (
    <InfoBanner
      variant="sales"
      closable={false}
      message={formatMessage({
        id: 'infoBanner.subscribeToUnlock',
        defaultMessage:
          'Subscribe to unlock everything Diagnocat has to offer.',
      })}
      linkText={
        isOwner
          ? formatMessage({
              id: 'infoBanner.subscribeToUnlock.link',
              defaultMessage: 'View plans',
            })
          : undefined
      }
      onLinkClick={isOwner ? handleBillingNavigate : undefined}
    />
  );
};
